import { Box } from '@mui/material';
import OrderConfirmationEditPane from '../components/EditPanes/OrderConfirmationEditPane';
import OrderConfirmationLiveView from '../components/LiveViews/OrderConfirmationLiveView';
import PreviewPane from '../components/Layout/PreviewPane';
import { OrderConfirmationPaymentProvider } from '../context/OrderConfirmationPaymentContext';

const OrderConfirmationBuilder = () => {
  return (
    <OrderConfirmationPaymentProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          flex: 1,
          minHeight: 0,
          height: '100%',
          overflow: { xs: 'auto', md: 'hidden' },
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', md: 400 },
            order: { xs: 1, md: 1 },
            flexShrink: 0,
            backgroundColor: '#fff',
            borderRight: { md: '1px solid #e0e0e0' },
            overflow: 'auto',
            height: { xs: 'auto', md: '100%' },
          }}
        >
          <OrderConfirmationEditPane />
        </Box>
        <PreviewPane
          title="Order Confirmation preview"
          sx={{
            order: { xs: 2, md: 2 },
            overflow: 'auto',
          }}
        >
          <OrderConfirmationLiveView />
        </PreviewPane>
      </Box>
    </OrderConfirmationPaymentProvider>
  );
};

export default OrderConfirmationBuilder;
